module.exports = __webpack_public_path__ + "img/0Q3A2496_FoamcoreMatted.eed919e3.jpg";